<div class="background-skills">
  <div class="container">

    <div class="skills">
      <h1>Skills</h1>

      <div class="skill">
        <span class="skill-name">Angular</span>
        <div class="skill-bar">
          <div class="skill-per md-9"></div>
        </div>
      </div>

      <div class="skill">
        <span class="skill-name">Typescript</span>
        <div class="skill-bar">
          <div class="skill-per md-9"></div>
        </div>
      </div>

      <div class="skill">
        <span class="skill-name">HTML</span>
        <div class="skill-bar">
          <div class="skill-per md-7"></div>
        </div>
      </div>

      <div class="skill">
        <span class="skill-name">CSS</span>
        <div class="skill-bar">
          <div class="skill-per md-5"></div>
        </div>
      </div>

      <div class="skill">
        <span class="skill-name">Git</span>
        <div class="skill-bar">
          <div class="skill-per md-8"></div>
        </div>
      </div>

      <div class="skill">
        <span class="skill-name">SQL</span>
        <div class="skill-bar">
          <div class="skill-per md-7"></div>
        </div>
      </div>

      <div class="skill">
        <span class="skill-name">Node.js</span>
        <div class="skill-bar">
          <div class="skill-per md-5"></div>
        </div>
      </div>

      <div class="skill">
        <span class="skill-name">Docker</span>
        <div class="skill-bar">
          <div class="skill-per md-4"></div>
        </div>
      </div>

    </div>
  </div>
</div>
